/**
 * A canvas for drawing interactivity
 */
import '../css/SemanticTools.scss'
import { _hub_touchPoints } from './hub'
import ToolBackground from './tools/ToolBackground'
import ToolIcon from './tools/ToolIcon'
import React, { createRef, PureComponent } from 'react'

let lastStartPoint = [0, 0]
let thisCircleD = 0

export default class SemanticTools extends PureComponent {
  constructor(props) {
    super(props)

    this.p5 = null
    this.canvasHolder = createRef()

    this.icons = {
      wheel: createRef(),
      plus: createRef(),
      minus: createRef(),
      left: createRef(),
      right: createRef(),
    }
    this.bgRef = createRef()
  }

  sketch(element, p) {
    p.setup = function () {
      p.createCanvas(window.innerWidth, window.innerHeight)
      // p.strokeWeight(4)
      p.noStroke()
    }

    p.draw = function () {
      p.clear()
      // p.background(0)
      if (_hub_touchPoints.start) {
        lastStartPoint = _hub_touchPoints.start
        // displayToolWheel()
        thisCircleD = visCircle(p, _hub_touchPoints)
      } else if (thisCircleD > 1) {
        thisCircleD = p.lerp(thisCircleD, 0, 0.3)
        visCircle(p, {
          start: lastStartPoint,
          thisD: thisCircleD,
        })
      }
    }

    p.windowResized = function () {
      p.resizeCanvas(window.innerWidth, window.innerHeight)
    }
  }

  componentDidMount() {
    // if (!this.p5)
    //   this.p5 = new p5(this.sketch.bind(this, this), this.canvasHolder.current)
  }

  componentWillUnmount() {
    if (this.p5 !== null) {
      this.p5.noLoop()
      this.p5.remove()
      delete this.p5
      this.p5 = null
    }
  }

  render() {
    return (
      <div id="tools" ref={this.canvasHolder}>
        {/* ... id="defaultCanvas0" class="p5Canvas" */}
        <div ref={this.icons.wheel} className="tool-wheel" id="tool-wheel">
          <ToolBackground bgRef={this.bgRef} />
          <ToolIcon holderRef={this.icons.left} name={'left'} />
          <ToolIcon holderRef={this.icons.right} name={'right'} />
        </div>
      </div>
    )
  }
}

const visCircle = (p, { start, now, thisD }) => {
  // p.push()
  // p.noFill()

  let d
  if (thisD) {
    d = thisD
  } else {
    d = p.dist(...start, ...now) << 1
    d = d < 60 ? 60 : d
  }

  // p.stroke(120, circleStrokeColor(p, d))

  p.push()
  // p.fill(60, 120, 170, circleFillColor(p, d))
  p.fill(60, 120, 170, 50)
  // p.drawingContext.setLineDash([2, 4])
  p.circle(...start, d)
  p.pop()
  // p.line(...start, ...now)

  // p.pop()
  return d
}

// const circleStrokeColor = (p, d) => {
//   return p.map(d, 0, window.innerWidth >> 1, 0, 120)
// }

const circleFillColor = (p, d) => {
  return p.constrain(p.map(d, 0, window.innerWidth >> 1, 20, 60), 0, 100)
}
